export default __webpack_public_path__ + "static/media/leaf5.a1ce6d67.svg";